import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { Row, Col, VertContainer } from '@vertem-core/vertice-ds';

import 'Assets/styles/default/components/LikePlus/LikePlusMainBannerStyles.less';

const LikePlusMainBanner = ({ bannerImage }) => {
  const renderDesktopBanner = (
    <Row gutter={0} className="like-plus-main-banner">
      <Col className="main-banner-image">
        <img
          alt={bannerImage?.alt}
          className="mw-100"
          src={bannerImage?.desktopUrl}
        />
      </Col>
    </Row>
  );

  const renderTabletBanner = (
    <Row gutter={0} className="like-plus-main-banner">
      <Col className="main-banner-image">
        <img
          alt={bannerImage?.alt}
          className="mw-100"
          src={
            bannerImage?.tabletUrl ||
            bannerImage?.desktopUrl
          }
        />
      </Col>
    </Row>
  );

  const renderMobileBanner = (
    <Row gutter={0} className="like-plus-main-banner">
      <Col className="main-banner-image">
        <img
          alt={bannerImage?.alt}
          className="mw-100"
          src={
            bannerImage?.mobileUrl ||
            bannerImage?.tabletUrl
          }
        />
      </Col>
    </Row>
  );

  return (
    <VertContainer fluid>
      {/* Desktop */}
      <MediaQuery minWidth={1200}>{renderDesktopBanner}</MediaQuery>

      {/* tablet */}
      <MediaQuery minWidth={481} maxWidth={1200}>
        {renderTabletBanner}
      </MediaQuery>

      {/* Mobile */}
      <MediaQuery maxWidth={480}>{renderMobileBanner}</MediaQuery>
    </VertContainer>
  );
};

LikePlusMainBanner.propTypes = {
  bannerImage: PropTypes.object.isRequired,
};

export default LikePlusMainBanner;
